(function(){})();
(function(){
  function etkT(key, fallback){ return (window.ETKText && window.ETKText[key]) || fallback; }
  function C(){ return document.querySelector('.product__info-container'); }

  var ETK_SPARK='M12 2.4l2.95 5.98 6.6.96-4.78 4.66 1.13 6.57L12 17.43l-5.9 3.1 1.13-6.57L2.45 9.3l6.6-.96z';
  function etkEtoile(etat){
    var ns='http://www.w3.org/2000/svg';
    var svg=document.createElementNS(ns,'svg');
    svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('aria-hidden','true');
    svg.classList.add('etk-etoile'); if(etat==='empty') svg.classList.add('etk-etoile-vide');
    var p=document.createElementNS(ns,'path'); p.setAttribute('d',ETK_SPARK);
    p.setAttribute('stroke','#111'); p.setAttribute('stroke-width','1.4'); p.setAttribute('stroke-linejoin','round');
    if(etat==='full'){ p.setAttribute('fill','#00B77F'); }
    else if(etat==='half'){
      var id='etkdemi'+Math.random().toString(36).slice(2,7);
      var defs=document.createElementNS(ns,'defs');
      var lg=document.createElementNS(ns,'linearGradient'); lg.setAttribute('id',id);
      var s1=document.createElementNS(ns,'stop'); s1.setAttribute('offset','50%'); s1.setAttribute('stop-color','#00B77F');
      var s2=document.createElementNS(ns,'stop'); s2.setAttribute('offset','50%'); s2.setAttribute('stop-color','#FFFFFF');
      lg.appendChild(s1); lg.appendChild(s2); defs.appendChild(lg); svg.appendChild(defs);
      p.setAttribute('fill','url(#'+id+')');
    } else { p.setAttribute('fill','#FFFFFF'); }
    svg.appendChild(p); return svg;
  }
  function etoilesMaison(){
    // 07/09/2026 : on ne remplace PLUS les etoiles de Loox. Ce calque existait parce que Loox
    // servait des etoiles noires ; Rafael a mis le vert-jaune Etilik dans Loox > Settings >
    // Branding > Star rating le meme jour, donc les vraies etoiles Loox sont deja a la bonne
    // couleur et le calque ne faisait que les cacher. Il reste seulement le remplissage de
    // .etk-sr-stars, qui est NOTRE ligne de note boutique et n'appartient pas a Loox.
    var box=document.querySelector('.etk-sr-stars');
    if(box && !box.childNodes.length){ for(var i=0;i<5;i++) box.appendChild(etkEtoile('full')); }
  }

  function etkCouleurs(){
    if(window.__etkCoul!==undefined) return window.__etkCoul;
    window.__etkCoul=null;
    var el=document.getElementById('etk-couleurs');
    if(el){ try{ window.__etkCoul=JSON.parse(el.textContent); }catch(e){} }
    if(window.__etkCoul){
      var vus={},cles=[];
      Object.keys(window.__etkCoul).forEach(function(v){
        var k=(v.split('·')[0]||'').trim().toLowerCase();
        if(k && !vus[k]){ vus[k]=1; cles.push(k); }
      });
      window.__etkCles=cles;
    }
    return window.__etkCoul;
  }

  function champCouleur(c){
    var vus=[];
    Array.prototype.slice.call(c.querySelectorAll('fieldset')).forEach(function(f){
      var lg=f.querySelector('legend');
      if(lg && /couleur|color|colour|farbe|barva/i.test(lg.textContent||'')) vus.push(f);
    });
    for(var i=0;i<vus.length;i++){
      if(vus[i].classList.contains('etk-grille-couleurs')) return vus[i];
      if(vus[i].offsetParent!==null && vus[i].getClientRects().length) return vus[i];
    }
    return null;
  }

  function miniaturesCouleur(c){
    var map=etkCouleurs(); if(!map) return;
    var fs=champCouleur(c); if(!fs) return;
    var labs=Array.prototype.slice.call(fs.querySelectorAll('label'));
    if(!labs.length) return;
    for(var k=0;k<labs.length;k++){
      var idk=labs[k].getAttribute('for');
      var ink=(idk&&document.getElementById(idk))||labs[k].previousElementSibling;
      if(!ink||!ink.value||!map[ink.value]) return;
    }
    fs.classList.add('etk-grille-couleurs');
    labs.forEach(function(l){
      if(l.querySelector('.etk-mini-img')) return;
      var id=l.getAttribute('for');
      var inp=(id&&document.getElementById(id))||l.previousElementSibling;
      var val=(inp&&inp.value)||'';
      var src=map[val]; if(!src) return;
      var im=document.createElement('img');
      im.className='etk-mini-img'; im.src=src; im.alt=''; im.setAttribute('aria-hidden','true');
      l.insertBefore(im,l.firstChild);
      if(/blanc|vanilla|white/i.test(val)) l.classList.add('etk-clair');
    });
  }

  function filtrerGalerie(c){
    var map=etkCouleurs(); if(!map||!window.__etkCles||!window.__etkCles.length) return;
    var fs=champCouleur(c); if(!fs) return;
    var inp=fs.querySelector('input:checked'); if(!inp||!inp.value) return;
    var choisie=(inp.value.split('·')[0]||'').trim().toLowerCase(); if(!choisie) return;
    var g=document.querySelector('media-gallery'); if(!g) return;
    var items=Array.prototype.slice.call(g.querySelectorAll('.product__media-item, .thumbnail-list__item'));
    if(!items.length) return;
    var cles=window.__etkCles, garde=0;
    var etat=items.map(function(it){
      var im=it.querySelector('img'); var alt=((im&&im.alt)||'').toLowerCase();
      var porte=null;
      for(var k=0;k<cles.length;k++){ if(alt.indexOf(cles[k])>=0){ porte=cles[k]; break; } }
      if(!porte || porte===choisie) garde++;
      return porte;
    });
    if(!garde) return;
    items.forEach(function(it,i){
      var cacher = etat[i] && etat[i]!==choisie;
      if(cacher){ if(!it.hasAttribute('data-etk-cache')) it.setAttribute('data-etk-cache','1'); }
      else if(it.hasAttribute('data-etk-cache')) it.removeAttribute('data-etk-cache');
    });
  }

  function noteBoutique(c){
    var sr=document.querySelector('.etk-sr'); if(!sr) return;
    var lx=c.querySelector('div.loox-rating .loox-rating-content');
    if(!lx){ if(sr.hidden && window.__etkTard) sr.hidden=false; return; }
    if(!sr.hidden) sr.hidden=true;
    if(lx.querySelector('.etk-sr-suite')) return;
    var n=sr.getAttribute('data-note')||'', nb=sr.getAttribute('data-nb')||'';
    if(!n||!nb) return;
    var s=document.createElement('span'); s.className='etk-sr-suite';
    // « avis boutique » etait faux : ce compteur Loox (shop.metafields.loox.global_stats)
    // additionne les avis PRODUITS de toute la marque, pas les avis sur la boutique.
    // Le bloc Loox plus bas dit d'ailleurs « Avis sur le produit 2,7k / Avis sur la
    // boutique 359 » : garder le mot « boutique » ici se contredisait a l'ecran.
    // Constate le 08/09/2026 pendant le balayage des pages.
    s.textContent='· '+etkT('reviewSummary','{rating} · {count} avis clients').replace('{rating}',n).replace('{count}',nb);
    lx.appendChild(s);
  }

  function garderTaille(c){
    var fs=c.querySelector('fieldset.etk-grille-tailles'); if(!fs) return;
    if(fs.querySelectorAll('input[type="radio"]').length<2) window.__etkTailleOk=true;
    if(window.__etkGarde) return;
    window.__etkGarde=true;
    document.addEventListener('change',function(e){
      var t=e.target; if(!t||!t.closest||!t.closest('fieldset.etk-grille-tailles')) return;
      window.__etkTailleOk=true;
      var g=document.querySelector('fieldset.etk-grille-tailles'); if(g) g.classList.remove('etk-manque');
      [40,200,600].forEach(function(d){ setTimeout(function(){ var cc=C(); if(cc){ labelTaille(cc); marquerTaille(cc); } },d); });
    },true);
    document.addEventListener('click',function(e){
      var t=e.target; if(!t||!t.closest) return;
      if(t.closest('fieldset.etk-grille-tailles')){ window.__etkTailleOk=true; return; }
      if(!t.closest('button[name="add"], .product-form__submit, .shopify-payment-button, .etk-custom-btn')) return;
      var cc=C(); if(!cc) return;
      var g=cc.querySelector('fieldset.etk-grille-tailles'); if(!g) return;
      if(window.__etkTailleOk) return;
      e.preventDefault(); e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      g.classList.add('etk-manque');
      g.scrollIntoView({behavior:'smooth',block:'center'});
    },true);
  }

  function grilleTailles(c){
    c.querySelectorAll('fieldset.product-form__input').forEach(function(f){
      var lg=f.querySelector('legend');
      if(lg && /taille|size|größe|talla|tamaño|taglia|velikost/i.test(lg.textContent)) f.classList.add('etk-grille-tailles');
    });
  }

  function marquerTaille(c){
    var fs=c.querySelector('fieldset.etk-grille-tailles'); if(!fs) return;
    if(window.__etkTailleOk){ if(!fs.classList.contains('etk-choix-fait')) fs.classList.add('etk-choix-fait'); }
    else if(fs.classList.contains('etk-choix-fait')) fs.classList.remove('etk-choix-fait');
    Array.prototype.slice.call(fs.querySelectorAll('label')).forEach(function(l){
      var id=l.getAttribute('for');
      var inp=(id&&document.getElementById(id))||l.previousElementSibling;
      var ok=window.__etkTailleOk&&inp&&inp.tagName==='INPUT'&&inp.checked;
      if(ok){ l.style.setProperty('background','#111','important');
              l.style.setProperty('color','#fff','important');
              l.style.setProperty('border-color','#111','important');
              l.style.setProperty('font-weight','700','important'); }
      else { l.style.removeProperty('background'); l.style.removeProperty('color');
             l.style.removeProperty('border-color'); l.style.removeProperty('font-weight'); }
    });
  }

  function labelTaille(c){
    var fs=c.querySelector('fieldset.etk-grille-tailles'); if(!fs) return;
    var lg=fs.querySelector('legend'); if(!lg) return;
    lg.setAttribute('data-etk-unisex','\u00a0·\u00a0'+etkT('unisex','Unisexe'));
    var wrap=lg.querySelector('.etk-lbl');
    if(!wrap){
      var txt='Taille';
      Array.prototype.slice.call(lg.childNodes).forEach(function(n){
        if(n.nodeType===3){ var t=(n.textContent||'').trim(); if(t) txt=t; n.parentNode.removeChild(n); }
      });
      wrap=document.createElement('span'); wrap.className='etk-lbl'; wrap.textContent=txt;
      lg.insertBefore(wrap, lg.firstChild);
      fs.addEventListener('change', function(){ [40,200,600].forEach(function(d){ setTimeout(function(){ var cc=C(); if(cc){ labelTaille(cc); marquerTaille(cc); } },d); }); });
    }
    var val=wrap.querySelector('.etk-val');
    if(!val){ val=document.createElement('span'); val.className='etk-val'; wrap.appendChild(val); }
    var ch=fs.querySelector('input:checked');
    var v = (window.__etkTailleOk && ch && ch.value) ? ch.value : '';
    if(val.textContent !== v) val.textContent = v;
  }

  function labelCouleur(c){
    c.querySelectorAll('fieldset.product-form__input').forEach(function(f){
      if(!f.querySelector('input.color-swatch-input')) return;
      var lg=f.querySelector('legend'); if(!lg) return;
      var selected=lg.querySelector('[id^="selected-"], [data-selected-value], .etk-val');
      if(!selected) return;
      var wrap=lg.querySelector('.etk-coul');
      if(!wrap){
        Array.prototype.slice.call(lg.childNodes).forEach(function(n){ if(n.nodeType===3) lg.removeChild(n); });
        wrap=document.createElement('span'); wrap.className='etk-coul';
        wrap.appendChild(document.createTextNode(etkT('color','Coloris')));
        selected.classList.add('etk-val'); wrap.appendChild(selected); lg.appendChild(wrap);
      }
    });
  }

  var ETK_ICONES=[
    [/taille|size/i,'<path d="M3 15 15 3l6 6L9 21z"/><path d="M7 11l2 2M10 8l2 2M13 5l2 2"/>'],
    [/composition|mati|entretien/i,'<path d="M8.5 3.5 4 5.8l1.3 4.4 2.2-.7V20.5h9V9.5l2.2.7L20 5.8l-4.5-2.3a3.5 3.5 0 0 1-7 0z"/>'],
    [/visuel|conseil/i,'<path d="M15 4l5 5L8 21H3v-5z"/><path d="M12 7l5 5"/>'],
    [/livraison|retour|expedi|expédi/i,'<path d="M2 6h11v9H2z"/><path d="M13 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/>'],
    [/paiement|securis|sécuris/i,'<rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/>'],
    [/atelier/i,'<path d="M6 9V3h12v6"/><rect x="3" y="9" width="18" height="7" rx="1"/><path d="M6 14h12v7H6z"/>'],
    [/description/i,'<path d="M5 3h9l5 5v13H5z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/>']
  ];
  var ETK_TIROIRS_HS=[/guide des tailles/i, /paiement s(e|é)curis/i];
  var ETK_ARGS_HS=[/14 jours pour changer/i];
  function elaguer(c){
    Array.prototype.slice.call(c.children).forEach(function(e){
      var d=e.querySelector('details'); if(!d) return;
      var t=((d.querySelector('summary')||{}).textContent||'').replace(/\s+/g,' ').trim();
      for(var i=0;i<ETK_TIROIRS_HS.length;i++){ if(ETK_TIROIRS_HS[i].test(t)){ e.classList.add('etk-masque'); return; } }
    });
    c.querySelectorAll('[class*="icon-with-text"] li').forEach(function(li){
      var t=((li.querySelector('b,strong,h3,.h4')||{}).textContent||'').trim();
      for(var i=0;i<ETK_ARGS_HS.length;i++){ if(ETK_ARGS_HS[i].test(t)){ li.classList.add('etk-arg-hs'); return; } }
    });
  }

  function iconesTiroirs(c){
    c.querySelectorAll('details > summary').forEach(function(s){
      if(s.querySelector('.etk-ico')) return;
      var t=(s.textContent||'').replace(/\s+/g,' ').trim();
      for(var i=0;i<ETK_ICONES.length;i++){
        if(ETK_ICONES[i][0].test(t)){
          var sp=document.createElement('span'); sp.className='etk-ico'; sp.setAttribute('aria-hidden','true');
          sp.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'+ETK_ICONES[i][1]+'</svg>';
          s.insertBefore(sp, s.firstChild);
          break;
        }
      }
    });
  }

  var ETK_B_ISTRES='<path d="M3 15 15 3l6 6L9 21z"/>';
  function ico(p,plein){ return '<svg viewBox="0 0 24 24" fill="'+(plein?'currentColor':'none')+'" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'+p+'</svg>'; }
  function boutonAchat(c){
    return Array.prototype.slice.call(c.children).filter(function(e){
      if(e.querySelector('#etk-pdp-v2')||e.querySelector('.etk-sr')) return false;
      return !!e.querySelector('product-form, .product-form__submit, button[name="add"], .etk-custom-btn, .shopify-payment-button');
    })[0];
  }

  // ── Bloc de reassurance sous le bouton, 3 colonnes (Rafael 07/09/2026) ────────
  // Remplace les deux lignes de texte precedentes (ligneDelai + bandeGaranties).
  // Format et textes choisis par Rafael dans l'editeur (artifact a0074a3c), fautes corrigees
  // le 07/09 : « Vrais artistes » s'accorde au pluriel, et « tatoueurs et graphistes » est la
  // formule de sa charte de marque (01-MARQUE/BRAND/02-descriptions.md).
  // Les pictos sont SES dessins. Ils pesaient 140 a 210 Ko piece : c'etait 99 % de metadonnees
  // Illustrator planquees dans un <metadata>. Nettoyes, les trois font 3,3 Ko en tout.
  // Le delai reste lu dans le tiroir « Livraison », donc il suit le produit.
  // ⚠ Chaines en APOSTROPHES, jamais en guillemets : ce JS vit dans un litteral Python
  //   de pdp-v2.py, donc un " ecrit ici est mange a l'analyse et casse la page publiee
  //   (arrive le 07/09/2026 : toute la fiche produit HS, SyntaxError Unexpected number).
  var ETK_PIC = {
    atelier: '<svg viewBox="0 0 92 79.7" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M64.8,7.4l18.8,32.9-18.8,33H27.2L8.4,40.3,27.2,7.4h37.6M68.8.4H23.2L.4,40.3l22.8,39.8h45.5l22.7-39.8L68.8.4h0Z"></path><g><path fill="currentColor" d="M27.7,39.6l13.3,13.4,23.4-23.6-2.1-2.1-21.3,21.5h0l-11.2-11.3s-2.1,2.1-2.1,2.1Z"></path><polygon points="62.3 24.7 66.7 29.7 41.1 55.8 25.2 39.6 29.8 34.9 41 46.3 62.3 24.7"></polygon></g></svg>',
    colis:   '<svg viewBox="0 0 69.1 68.5" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M67.9,57l-33.5,9.7c-3.6-.6-7.3-1.8-10.7-2.7-7.4-2.1-14.9-4.5-22.5-6.8l-.3-.6c-.5-14.4-.5-28.8-.2-43.2L34.4,3.5l33.1,9.7.3,43.6v.2ZM42.5,9c-2.9-.5-5.7-2.3-8.7-2.3-8.1,2.7-16.8,4.5-24.7,7.3-7.9,2.7-1,.2-1,.8l8.4,2.1c8.2-2.7,17.1-4.5,25.4-7.3,8.2-2.7.8,0,.8-.6h-.2ZM35.7,23.2v39.9l28.8-8.4V15.4h-1.3c-4.5-1.1-10-3.6-14.4-4.2-4.4-.6-2.1,0-3.2.5-7.4,1.8-15.4,4.5-22.8,6.8-7.4,2.3-.8.2-1.3,0,0,.5.5.5.8.6,3.1,1.1,6.3,1.8,9.4,2.7s3.9,1.1,3.9,1.5l.2-.2ZM13.4,19.1l-9.5-2.6v38.2l9.5,2.9V19.1ZM32.6,25l-13.4-4c-.2-.3-.6.3-.6.3v37.5l1,.6,13.1,3.7V25Z"></path><path fill="currentColor" d="M59.1,44.2c.3-.3,1.6,1,1.6,1.1,0,.5-5.8,7.1-6.3,8.4-1,.5-2.7-1.6-3.6-2.3-.8-.6-1.1-.8-1.5-.8l-4,2.6c-.3-.3,3.2-7,2.6-8.2l-10.5-1.9c0-.5,1-.6,1.3-.8,1.3-.6,8.7-3.1,8.9-3.9,0-1.3-5-8.6-4.5-9.1l6,3.4c.5,0,5.3-5.8,6.1-6.6s.8-1,1.1-.8l4.5,6.5c-2.1,3.2-4.8,5.8-7.1,8.9-.3.8-.5,4.8-.3,5.8s1.9,2.4,2.4,2.4l3.4-4.5-.2-.2ZM53.6,37.4c.8-.6,4.2-4.4,4.2-5l-2.7-3.7c-.2.3-1.5,1.3-1.5,1.5,0,0,0,7.3,0,7.3Z"></path></svg>',
    artiste: '<svg viewBox="0 0 69.1 68.5" xmlns="http://www.w3.org/2000/svg"><g><g><path fill="currentColor" d="M41.9,37.6c-.2.6.3,1.1.3,1.7.1,1-.1,2-.3,2.9-.3,0-.6,0-.9,0s-.3-.2-.5-.2-.4.3-.9.2-.4-.3-.7-.3c-.3.5-.6.5-1.2.5s-.4-.3-.8-.6c-.1.5-.6.6-1.1.6-.8,0-1.2-.3-1.3-1.1,0,1.4-1,1-2.1,1l-.3-.4c-.5.6-1.5.8-1.9,0-.4.4-1.3.6-1.5,0-.4.2-1.5.6-1.7,0s-.2-1.4-.3-1.7,0-.6,0-.9c0-.6.5-1.1.3-1.7-3-1-7.9-.1-9.6-3.6s-.7-1.8-.2-2.8,1.5-1.5,1.5-3-1.6-4.7-1.8-7c-.8-10.2,8-19.1,18.3-18.5,10.2.6,18.3,10.5,15.9,20.7s-1.9,4.3-1,6.2,1.9,1.7,1.4,3.5c-1.4,4.6-6.3,3.4-9.9,4.5ZM25,21.7c-1,.2-1.7,1.4-2,2.3s-1.1,3.5-.4,4.6,3.5,1.6,4.7,1.5c2.2-.2,3.9-1.7,4.9-3.5s.3-3-1.8-3.7-2.7-.8-3.9-1-1.1-.2-1.6-.1ZM46.3,28.7c.9-1,.3-3,0-4.1s-1.2-3-2.9-2.9-5.3,1.1-6.3,1.8-.9,2.1-.1,3.2,2.5,3.1,4.5,3.3,4-.3,4.9-1.3ZM37.8,34.9c0-.1.1-.3.1-.5.1-1.6-1.3-4-2.3-5.3s-.8-1.1-1.4-.8-1,1.1-1.2,1.4c-1,1.4-2.1,3.3-1.8,5,0,.1,1.6.9,1.7.9.6,0,1-.9,1.4-.9.8-.1,1,.9,1.6.9s1.2-.7,1.8-.7Z"></path><path fill="currentColor" d="M52.8,38.8c.7-.7,1.9-1.2,2.9-1.1,1.6.2,1.7,1.9,2,3.2s2.2,1.5,1.9,3.7-2.2,3.7-4,3.2-.7-.9-1.2-.9-2.2.5-2.6.6c-2,.6-4,1.6-5.9,2.3-2.1.9-4.1,1.8-6.1,2.7.2.2.4.3.6.3,3,1.3,6.3,2.7,9.4,3.6,1.2.4,3.3,1.1,4.4.7s1.2-.7,2-.8c1.8-.1,3.7,1.1,3.3,3.1s-1,1.4-1.3,2.1,0,1.9-.5,2.9c-.9,1.8-4.9,2.1-5.7.2s0-1.3-.7-1.9c-2-1.7-6.1-3.2-8.6-4.4s-4.7-2.3-7-3.2-1.1-.4-2.1,0c-3.5,1.3-7.7,3.4-11.1,5s-3.3,1.5-4.5,2.5-.3,1.2-.7,2-2.1,1.3-3.1,1.2-2-.6-2.5-1.2-.3-1.3-.4-2.1c-.2-1.7-2.1-2.7-1.6-4.5s1.9-1.8,2.8-1.8,1.8.8,2.7.9c1.8.2,4.4-.8,6.1-1.4,2.7-.9,5.3-2.1,7.9-3.1,0-.2,0-.2-.2-.3-.4-.3-1.6-.7-2.2-1-2.9-1.3-6.6-3-9.6-3.9s-2.4-.6-2.6-.6c-.6,0-.6.8-1.4.9-2.2.3-4.8-2.9-3.5-4.9s.7-.6,1-.9c1.1-1.1.5-3.2,1.9-4.1s3.2,0,3.8,1.1.3,1.1.6,1.6c.9,2,5.6,4.2,7.6,5.2,2.5,1.2,5.4,2.7,8,3.7,1.8.7,2.5.4,4.1-.3,4-1.8,9.4-4,13-6.4s1.6-1.2,1.9-1.5c.5-.6.4-1.8,1.1-2.6Z"></path></g></g></svg>'
  };
  function blocPictos(c){
    if(c.querySelector('.etk-tri')) return;
    var btn=boutonAchat(c); if(!btn||!btn.parentNode) return;
    var delai='5 a 7 jours ouvres';
    var det=Array.prototype.slice.call(c.querySelectorAll('details')).filter(function(d){
      var t=d.querySelector('summary'); return t && /livraison/i.test(t.textContent||'');
    })[0];
    if(det){
      var m=(det.textContent||'').replace(/\s+/g,' ').match(/D[eé]lai de production\s*:\s*([^.(]+)/i);
      if(m && m[1].trim()) delai=m[1].trim();
    }
    // Textes raccourcis dictes par Rafael le 08/09/2026 a 13h39, pour que chaque ligne tienne
    // sur UNE ligne meme sur telephone (les colonnes n'y font que 113 px de large).
    // Le delai reste lu dans le tiroir « Livraison » : on abrege juste « jours » en « j ».
    // ⚠ PAS de  ni de \s dans une expression reguliere ecrite ici : ce JS vit dans un
    //   litteral Python, donc  devient un caractere RETOUR ARRIERE (code 8) dans le
    //   fichier publie et la regle ne matche plus jamais. Vu le 08/09/2026 : « 5 a 7 jours
    //   ouvres » ne s'abregeait pas. On fait un simple remplacement de texte.
    var delaiCourt=delai.replace('jours','j').replace('jour','j');
    var cols=[
      ['atelier', etkT('printed', 'Imprimé'),  etkT('workshop', 'Dans notre atelier')],
      ['artiste', etkT('tattoo', 'Tatoueurs'),  etkT('illustrators', '&amp; Illustrateurs')],
      ['retour',  etkT('returns', 'Retours'),    etkT('days14', 'Sous 14 jours')]
    ];
    // Ce qui n'a pas d'option de taille n'est PAS imprime par nous (tour de cou, casquette,
    // sticker, briquet, banane...). Rafael, 09/09/2026 : « ca ne convient pas pour cet article,
    // mets-le seulement pour tout ce qui est textile ». On garde le delai, qui lui est vrai :
    // tout part du meme atelier au fil de l'eau.
    if(!c.querySelector('.etk-textile')){
      // Rafael, 09/09/2026 12h38 : « 5 a 7 jours ouvres, c'est pas vendeur ». Sous le bouton
      // d'achat on met trois raisons d'acheter, pas un delai d'attente. Le delai reste ecrit
      // noir sur blanc dans le tiroir Livraison et dans la FAQ, la ou l'acheteur va le chercher.
      // Le seuil de livraison offerte ET sa devise viennent du serveur : ils suivent le
      // marche du visiteur (130 € France et Monaco, 250 ailleurs, en dollars aux USA).
      // Si le repere n'est pas la, on n'invente pas de chiffre : on n'affiche pas la ligne.
      var franco=c.querySelector('.etk-franco');
      var txtFranco=franco ? (franco.getAttribute('data-txt')||'') : '';
      cols=[
        ['colis',  etkT('dispatch', 'Expédition'), etkT('istres', 'Depuis Istres')],
        ['artiste',etkT('tattoo', 'Tatoueurs'),    etkT('illustrators', '&amp; Illustrateurs')],
        ['retour', etkT('returns', 'Retours'),      etkT('days14', 'Sous 14 jours')]
      ];
      if(txtFranco){
        cols=[
          ['livraison', etkT('shipping', 'Livraison offerte'), txtFranco.replace(/^Dès /, etkT('from', 'Dès')+' ')],
          ['colis',     etkT('dispatch', 'Expédition'),      etkT('istres', 'Depuis Istres')],
          ['retour',    etkT('returns', 'Retours'),          etkT('days14', 'Sous 14 jours')]
        ];
      }
    }
    // Casquettes et bobs : faits chez nous (Rafael, 09/09/2026 09h53), mais brodes ou patches,
    // pas imprimes — d'ou « Personnalise », le mot qu'il emploie sur la page collection.
    if(c.querySelector('.etk-casquette')){
      cols=[
        ['atelier', etkT('custom', 'Personnalisé'), etkT('workshop', 'Dans notre atelier')],
        ['artiste', etkT('tattoo', 'Tatoueurs'),      etkT('illustrators', '&amp; Illustrateurs')],
        ['retour',  etkT('returns', 'Retours'),        etkT('days14', 'Sous 14 jours')]
      ];
    }
    // La carte cadeau n'est ni imprimee ni expediee (Rafael, 09/09/2026) : trois reperes
    // qui repondent aux vraies questions qu'on se pose avant d'en offrir une.
    if(c.querySelector('.etk-cadeau')){
      cols=[
        ['mail',  etkT('mail', 'Par mail'),  etkT('immediate', 'Reçue tout de suite')],
        ['site',  etkT('valid', 'Valable'),   etkT('site', 'Sur tout le site')],
        ['solde', etkT('balance', 'Le solde'),  etkT('kept', 'Se garde')]
      ];
    }
    if(document.getElementById('etilik-customiseur-config')){
      cols[1]=['artiste', etkT('custom', 'Personnalisé'), etkT('yourDesign', 'Avec ton visuel')];
      cols[2]=['retour', etkT('minimum', 'Sans minimum'), etkT('one', 'Dès 1 pièce')];
    }
    var b=document.createElement('div'); b.className='etk-tri';
    var h='';
    for(var i=0;i<cols.length;i++){
      h+='<div class="etk-tri-col">'
       + '<p class="etk-tri-t">'+cols[i][1]+'</p>'
       + '<p class="etk-tri-s">'+cols[i][2]+'</p></div>';
    }
    b.innerHTML=h;
    btn.parentNode.insertBefore(b, btn.nextSibling);
    var args=c.querySelector('[class*="icon-with-text"]');
    if(args){ var bl=args.closest('.shopify-block'); if(bl) bl.classList.add('etk-args-hs'); }
  }

  function lotsDegressifs(c){
    if(c.querySelector('.etk-lots')) return;
    var src=c.querySelector('.etk-paliers'); if(!src) return;
    var brut=src.getAttribute('data-p')||''; if(!brut) return;
    var prix=parseInt(src.getAttribute('data-prix')||'0',10); if(!prix) return;
    var lignes=brut.split(',').map(function(x){
      var p=x.split(':'); return {min:+p[0], max:+p[1], pct:+p[2]};
    }).filter(function(l){ return l.min && l.pct; });
    if(!lignes.length) return;
    function euros(cts){ return (cts/100).toFixed(2).replace('.', ',')+' €'; }
    var box=document.createElement('div'); box.className='etk-lots';
    var html='<p class="etk-lots-t">'+etkT('quantityDiscount','Remise par quantité')+'</p><table><tbody>';
    lignes.forEach(function(l){
      var lib = l.max ? (l.min+' '+etkT('rangeTo','à')+' '+l.max) : (l.min+' '+etkT('rangePlus','et +'));
      html+='<tr><td>'+lib+'</td><td>−'+l.pct+' %</td><td>'+euros(Math.round(prix*(100-l.pct)/100))+' '+etkT('unit',"l'unité")+'</td></tr>';
    });
    html+='</tbody></table><p class="etk-lots-n">'+etkT('quantityNote','Remise appliquée automatiquement au panier, sans code.')+'</p>';
    box.innerHTML=html;
    var apres=c.querySelector('.etk-desc')||c.querySelector('.etk-bande')||c.querySelector('.etk-delai')||boutonAchat(c);
    if(apres&&apres.parentNode) apres.parentNode.insertBefore(box, apres.nextSibling);
  }

  function mentionUnisexe(c){
    if(!c.querySelector('.etk-unisexe')) return;
    var r=document.documentElement;
    if(!r.classList.contains('etk-uni-on')) r.classList.add('etk-uni-on');
    if(c.querySelector('fieldset.etk-grille-tailles legend')) return;
    if(c.querySelector('.etk-uni')) return;
    var eye=c.querySelector('.etk-eyebrow');
    if(eye && !eye.hasAttribute('hidden')){
      var el=document.createElement('span'); el.className='etk-uni'; el.textContent=etkT('unisex','Unisexe');
      eye.appendChild(el);
    }
  }

  // bandeGaranties() retiree le 07/09/2026 : remplacee par blocPictos(), 3 colonnes.

  // ── Mise en forme des tiroirs : intitules en petits titres, valeurs rapprochees ──────
  // Le contenu des tiroirs vient des metachamps produit : ce sont des <p> tous identiques,
  // donc a l'ecran un intitule ressemble a une valeur et l'oeil ne raccroche rien.
  // On reconnait les intitules par une LISTE FERMEE (pas d'heuristique : « Oversized, boxy,
  // unisexe » fait 24 signes sans point et serait pris pour un titre a tort).
  var ETK_TIR_TITRES = ['grammage','composition','composition & matiere','composition et matiere',
    'coupe','certifications','entretien','matiere','delais de livraison','delai de livraison',
    'retours','livraison','suivi','lavage','origine','impression'];
  function etkSansAccent(s){
    return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/\s+/g,' ').trim();
  }
  function tiroirsLisibles(c){
    var zones=c.querySelectorAll('.accordion__content');
    Array.prototype.forEach.call(zones, function(z){
      if(z.classList.contains('etk-tir-fait')) return;
      var ps=z.querySelectorAll('p');
      if(!ps.length) return;
      z.classList.add('etk-tir-fait');
      Array.prototype.forEach.call(ps, function(p){
        if(p.querySelector('img,iframe,table')) return;
        // ⛔ Ne JAMAIS toucher a un <p> qui porte deja une classe : le guide des tailles et les
        // pictos posent les leurs (.etk-gt-*, .etk-tri-*) et on les effacerait.
        if(p.className) return;
        var t=(p.textContent||'').trim();
        if(!t) return;
        var cle=etkSansAccent(t).replace(/[:\.]$/,'');
        if(ETK_TIR_TITRES.indexOf(cle)>=0){ p.classList.add('etk-tir-h'); return; }
        p.classList.add('etk-tir-v');
        // « Intitule : valeur » sur une meme ligne -> on met l'intitule en gras
        var m=t.match(/^([^:]{2,34}) : ([\s\S]+)$/);
        if(m && p.children.length===0){
          var b=document.createElement('b'); b.textContent=m[1];
          p.textContent=''; p.appendChild(b); p.appendChild(document.createTextNode(' : '+m[2]));
        }
      });
    });
  }

  // Une carte cadeau digitale n'a pas de stock : « En stock » devient « Disponible »
  // (Rafael, 09/09/2026). On ne touche qu'au texte, la pastille verte reste.
  function motDisponible(c){
    if(!c.querySelector('.etk-cadeau')) return;
    var inv=c.querySelector('.product__inventory'); if(!inv) return;
    (function walk(n){
      for(var i=0;i<n.childNodes.length;i++){
        var k=n.childNodes[i];
        if(k.nodeType===3){
          if(k.textContent.toLowerCase().indexOf('en stock')>-1){
            k.textContent=k.textContent.replace(/[Ee]n stock/, 'Disponible');
          }
        } else if(k.nodeType===1) walk(k);
      }
    })(inv);
  }

  // Le tiroir « Livraison et retours » ouvre sur « Chaque vetement est imprime a la demande
  // dans notre atelier ». Faux sur un tour de cou ou une casquette (Rafael, 09/09/2026).
  // On ne touche QUE la premiere phrase, et seulement quand le produit n'est pas du textile.
  function phraseAtelier(c){
    if(c.querySelector('.etk-textile')) return;
    var cq=!!c.querySelector('.etk-casquette');
    var det=Array.prototype.slice.call(c.querySelectorAll('details')).filter(function(d){
      var s=d.querySelector('summary'); return s && /livraison/i.test(s.textContent||'');
    })[0];
    if(!det) return;
    var ps=Array.prototype.slice.call(det.querySelectorAll('p'));
    for(var i=0;i<ps.length;i++){
      var t=ps[i].textContent||'';
      if(t.indexOf('imprim')>-1 && t.indexOf('atelier')>-1){
        ps[i].textContent = cq
          ? 'Chaque pièce est personnalisée dans notre atelier à Istres, après le passage de ta commande.'
          : 'Chaque commande est préparée et expédiée depuis notre atelier à Istres.';
      }
      // « Delai de production » reste vrai pour une casquette : on la fabrique. Pour un tour de
      // cou ou une tenture, on ne fabrique rien, c'est une preparation.
      if(!cq && t.indexOf('Délai de production')>-1){
        ps[i].innerHTML=ps[i].innerHTML.replace('Délai de production','Délai de préparation');
      }
    }
    // Meme phrase, deuxieme endroit : la FAQ en bas de page (« Quels sont les delais de
    // livraison ? »). Elle est HORS de la colonne produit, donc on la cherche dans toute la
    // page. On ne remplace que ce paragraphe-la, mot pour mot (Rafael, 09/09/2026).
    // ATTENTION : tester en MINUSCULES. « Imprime dans notre atelier... » commence par une
    // majuscule, indexOf('imprim') ne le trouvait pas et la phrase du bloc de reassurance
    // restait fausse sur un tour de cou (vu le 09/09/2026 a 10h05).
    var tous=Array.prototype.slice.call(document.querySelectorAll('p, .h4, h3, strong, b'));
    for(var j=0;j<tous.length;j++){
      var el=tous[j], x=(el.textContent||''), xb=x.toLowerCase();
      if(x.length>190) continue;
      if(xb.indexOf('atelier')<0) continue;
      // 1. « Chaque vetement est imprime a la demande dans notre atelier a Istres... »
      if(xb.indexOf('chaque v')===0 && xb.indexOf('imprim')>-1){
        el.textContent = cq
          ? 'Chaque pièce est personnalisée dans notre atelier à Istres, après le passage de ta commande.'
          : 'Chaque commande est préparée et expédiée depuis notre atelier à Istres.';
        continue;
      }
      // 2. « Imprime dans notre atelier a Istres avec des encres resistantes... » (reassurance)
      if(xb.indexOf('imprim')===0 && xb.indexOf('encres')>-1){
        el.textContent = cq
          ? 'Personnalisé dans notre atelier à Istres, pièce par pièce.'
          : 'Chaque pièce est contrôlée dans notre atelier à Istres avant de partir.';
        continue;
      }
      // 3. son intitule : « Qualite d'impression solide et durable »
      if(xb.indexOf('qualit')===0 && xb.indexOf('impression')>-1){
        // PIEGE (09/09/2026 10h08) : ce JS vit dans un litteral Python. Une apostrophe
        // echappee \' y devient une apostrophe NUE dans le fichier publie et casse toute la
        // feuille de script. On utilise l'apostrophe typographique ’, sans echappement.
        el.textContent = cq ? 'Personnalisation soignée' : 'Contrôlé avant l’envoi';
        continue;
      }
      if(!cq && x.indexOf('Délai de production')>-1){
        el.innerHTML=el.innerHTML.replace('Délai de production','Délai de préparation');
      }
    }
  }

  function tiroirAtelier(c){
    if(c.querySelector('.etk-tiroir')) return;
    // Sur la carte cadeau ce tiroir reprenait mot pour mot « Comment ca marche » sous un titre
    // « NOTRE ATELIER » qui ne veut rien dire pour un produit digital (Rafael, 09/09/2026).
    if(c.querySelector('.etk-cadeau')) return;
    var args=c.querySelector('[class*="icon-with-text"]'); if(!args) return;
    var items=Array.prototype.slice.call(args.querySelectorAll('li')).map(function(li){
      var t=(li.querySelector('b,strong,h3,.h4')||{}).textContent||'';
      var p=(li.querySelector('p')||{}).textContent||'';
      return [t.trim(), p.replace(/\s+/g,' ').trim()];
    }).filter(function(x){return x[0]||x[1];});
    if(!items.length) return;
    var blocs=Array.prototype.slice.call(c.children).filter(function(e){
      return e.querySelector('details') && !e.classList.contains('etk-masque') && !e.classList.contains('etk-tiroir');
    });
    if(!blocs.length) return;
    var clone=blocs[blocs.length-1].cloneNode(true);
    clone.classList.add('etk-tiroir'); clone.removeAttribute('id');
    var det=clone.querySelector('details'); if(!det) return; det.open=false;
    var sum=det.querySelector('summary'); if(!sum) return;
    var vieilleIco=sum.querySelector('.etk-ico'); if(vieilleIco) vieilleIco.remove();
    var fait=false;
    (function walk(n){ if(fait) return;
      for(var i=0;i<n.childNodes.length;i++){ var k=n.childNodes[i];
        if(k.nodeType===3 && k.textContent.trim().length>1){ k.textContent=etkT('ourWorkshop','NOTRE ATELIER'); fait=true; return; }
        if(k.nodeType===1) walk(k); if(fait) return; } })(sum);
    if(!fait) return;
    var corps=sum.nextElementSibling; if(!corps) return;
    corps.innerHTML=items.map(function(x){return '<p><strong>'+x[0]+'</strong></p><p>'+x[1]+'</p>';}).join('');
    blocs[blocs.length-1].parentNode.insertBefore(clone, blocs[blocs.length-1].nextSibling);
  }

  function panneauTailles(c){
    if(document.querySelector('.etk-sc')) return;
    var lien=c.querySelector('.etk-guide a'); if(!lien) return;
    var det=Array.prototype.slice.call(c.querySelectorAll('details')).filter(function(d){
      var s=d.querySelector('summary'); return s && /guide des tailles/i.test(s.textContent||'');
    })[0];
    var neuf=det?det.querySelector('.etk-gt'):null;
    var src=det?det.querySelector('img'):null;
    if(!neuf && !src) return;
    var url=src?(src.getAttribute('src')||src.currentSrc||src.src):'';
    if(!neuf && !url) return;
    var ov=document.createElement('div'); ov.className='etk-sc-ov';
    var pa=document.createElement('div'); pa.className='etk-sc';
    pa.setAttribute('role','dialog'); pa.setAttribute('aria-modal','true'); pa.setAttribute('aria-label',etkT('sizeGuide','Guide des tailles'));
    pa.innerHTML='<header><h2>Guide des tailles</h2><button class="etk-sc-x" type="button" aria-label="Fermer"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.8" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg></button></header><div class="etk-sc-body"></div>';
    pa.querySelector('h2').textContent=etkT('sizeGuide','Guide des tailles');
    pa.querySelector('.etk-sc-x').setAttribute('aria-label',etkT('close','Fermer'));
    var corps=pa.querySelector('.etk-sc-body');
    if(neuf){
      pa.classList.add('etk-sc--large');
      var cl=neuf.cloneNode(true), sfx='-'+Math.random().toString(36).slice(2,7);
      Array.prototype.slice.call(cl.querySelectorAll('input[type="radio"][name]')).forEach(function(i){ i.name=i.name+sfx; });
      Array.prototype.slice.call(cl.querySelectorAll('.etk-gt-finder')).forEach(function(x){ x.removeAttribute('data-on'); });
      corps.appendChild(cl);
      if(window.etkGuideInit) window.etkGuideInit(cl);
      else { var s0=det.parentNode.querySelector('script'); if(s0){ var s1=document.createElement('script'); s1.textContent=s0.textContent; document.head.appendChild(s1); if(window.etkGuideInit) window.etkGuideInit(cl); } }
    } else {
      var img=document.createElement('img'); img.src=url; img.alt=etkT('sizeGuide','Guide des tailles'); img.loading='lazy';
      corps.appendChild(img);
    }
    var note=document.createElement('p'); note.className='etk-sc-note';
    note.textContent=etkT('sizeNote','Mesures à plat, en centimètres. Pour obtenir le tour, double la largeur. Le plus simple reste de comparer avec un vêtement que tu portes déjà.');
    if(!neuf) corps.appendChild(note);
    document.body.appendChild(ov); document.body.appendChild(pa);
    var dernier=null;
    function ouvrir(e){ if(e){e.preventDefault(); e.stopPropagation();}
      dernier=document.activeElement; ov.classList.add('on'); pa.classList.add('on');
      document.body.style.overflow='hidden'; pa.querySelector('.etk-sc-x').focus(); }
    function fermer(){ ov.classList.remove('on'); pa.classList.remove('on');
      document.body.style.overflow=''; if(dernier&&dernier.focus) dernier.focus(); }
    if(!window.__etkGuideClic){
      window.__etkGuideClic=true;
      document.addEventListener('click',function(ev){
        var t=ev.target; if(!t||!t.closest) return;
        if(t.closest('.etk-guide a')) ouvrir(ev);
      },true);
    }
    ov.addEventListener('click',fermer);
    pa.querySelector('.etk-sc-x').addEventListener('click',fermer);
    document.addEventListener('keydown',function(ev){ if(ev.key==='Escape'&&pa.classList.contains('on')) fermer(); });
    if(/[?&]etk_guide=1/.test(location.search)) setTimeout(ouvrir,900);
  }

  function descriptionVisible(c){
    if(c.querySelector('.etk-desc')) return;
    var det=Array.prototype.slice.call(c.querySelectorAll('details')).filter(function(d){
      var s=d.querySelector('summary'); return s && /^description$/i.test((s.textContent||'').replace(/\s+/g,' ').trim());
    })[0];
    if(!det) return;
    var s=det.querySelector('summary'), body=s?s.nextElementSibling:null; if(!body) return;
    var ps=Array.prototype.slice.call(body.querySelectorAll('p')).map(function(p){return (p.textContent||'').replace(/\s+/g,' ').trim();}).filter(Boolean);
    if(!ps.length) return;
    var box=document.createElement('div'); box.className='etk-desc';
    ps.forEach(function(t,i){
      var p=document.createElement('p'); p.textContent=t;
      box.appendChild(p);
    });
    var btn=Array.prototype.slice.call(c.children).filter(function(e){
      if(e.querySelector('#etk-pdp-v2')||e.querySelector('.etk-sr')) return false;
      return !!e.querySelector('product-form, .product-form__submit, button[name="add"], .etk-custom-btn, .shopify-payment-button');
    })[0];
    var bloc=det.closest('.shopify-block');
    var apres=c.querySelector('.etk-bande')||c.querySelector('.etk-delai')||btn;
    if(apres && apres.parentNode){ apres.parentNode.insertBefore(box, apres.nextSibling); if(bloc) bloc.classList.add('etk-masque'); }
  }

  function poserGuide(c){
      var enfants=Array.prototype.slice.call(c.children);
      var blocDoute=enfants.filter(function(e){
        return !e.querySelector('.etk-sr') && !e.querySelector('#etk-pdp-v2') && !e.querySelector('details')
               && !e.querySelector('fieldset') && /doute sur ta taille/i.test(e.innerText||'');
      })[0];
      var fsz=c.querySelector('fieldset.etk-grille-tailles');
      var lg=fsz?fsz.querySelector('legend'):null;
      if(fsz && blocDoute){
        var a=blocDoute.querySelector('a');
        if(a){
          if(!fsz.querySelector('.etk-guide')){
            var sp=document.createElement('span'); sp.className='etk-guide';
            var lk=a.cloneNode(true); lk.innerHTML='';
            lk.insertAdjacentHTML('afterbegin','<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 15 15 3l6 6L9 21z"/><path d="M7 11l2 2M10 8l2 2M13 5l2 2"/></svg>');
            lk.appendChild(document.createTextNode(etkT('sizeGuide','Guide des tailles')));
            sp.appendChild(lk); fsz.appendChild(sp);
          }
          blocDoute.classList.add('etk-masque');
        }
      }
  }

  function pdpV2(){
    var c=C(); if(!c) return;
    grilleTailles(c); garderTaille(c); labelTaille(c); marquerTaille(c); labelCouleur(c); miniaturesCouleur(c); filtrerGalerie(c); etoilesMaison(); noteBoutique(c); elaguer(c); mentionUnisexe(c); descriptionVisible(c); blocPictos(c); lotsDegressifs(c); tiroirAtelier(c); tiroirsLisibles(c); motDisponible(c); phraseAtelier(c);  panneauTailles(c);
    var eye=c.querySelector('.etk-eyebrow');
    if(eye && eye.hasAttribute('hidden')){
      var h1=c.querySelector('h1');
      if(h1 && h1.parentNode){ h1.parentNode.insertBefore(eye,h1); eye.removeAttribute('hidden'); }
    }
    var enfants=Array.prototype.slice.call(c.children);
    enfants.forEach(function(e){ e.classList.remove('etk-filet','etk-haut','etk-stock'); });
    poserGuide(c);
    var iVar=-1;
    enfants.forEach(function(e,k){ if(iVar<0 && e.querySelector('fieldset.etk-grille-tailles')) iVar=k; });
    if(iVar<0){ /* pas de selecteur de taille (accessoires) : on se cale sur le bouton d'achat */
      enfants.forEach(function(e,k){
        if(iVar<0 && e.querySelector('product-form, .product-form__submit, button[name="add"], .etk-custom-btn, .shopify-payment-button')) iVar=k;
      });
    }
    enfants.forEach(function(e,k){
      if(e.classList.contains('etk-masque')) return;
      if(iVar>0 && k>0 && k<iVar) e.classList.add('etk-haut');
      if(k===iVar) e.classList.add('etk-filet');
      if(/^\s*en stock\s*$/i.test((e.innerText||'').trim())) e.classList.add('etk-stock');
    });
    var prevAcc=false, prevVide=true;
    enfants.forEach(function(el){
      if(el.classList.contains('etk-masque')) return;
      el.classList.remove('etk-vide','etk-collee','etk-acc-debut');
      if(el.getBoundingClientRect().height < 2){ el.classList.add('etk-vide'); return; }
      var acc=!!el.querySelector('details');
      if(acc && prevAcc) el.classList.add('etk-collee');
      if(acc && !prevAcc && !prevVide) el.classList.add('etk-acc-debut');
      prevAcc=acc; prevVide=false;
    });
  }

  function prixNoir(){
    var c=C(); if(!c) return;
    function F(el,col,fw,fs){ if(!el) return; el.style.setProperty('color',col,'important');
      el.style.setProperty('font-weight',fw,'important'); el.style.setProperty('font-size',fs,'important'); }
    F(c.querySelector('.price__regular .price-item--regular'),'#111','700','22px');
    F(c.querySelector('.price__sale .price-item--sale'),'#111','700','22px');
    F(c.querySelector('.price__sale .price-item--regular'),'#8a8a8a','400','15px');
  }
  function suivreVariantes(){
    if(window.__etkObsGlobal||!window.MutationObserver) return;
    var dedans=false;
    function passe(){
      if(dedans) return; dedans=true;
      window.__etkObsGlobal.disconnect();
      try{
        var cc=C();
        if(cc){ grilleTailles(cc); poserGuide(cc); labelTaille(cc); marquerTaille(cc); labelCouleur(cc); miniaturesCouleur(cc); filtrerGalerie(cc); noteBoutique(cc);
                mentionUnisexe(cc); blocPictos(cc); tiroirAtelier(cc); tiroirsLisibles(cc); motDisponible(cc); phraseAtelier(cc); descriptionVisible(cc); lotsDegressifs(cc);  prixNoir(); }
      }catch(e){}
      window.__etkObsGlobal.observe(document.body,{childList:true,subtree:true});
      dedans=false;
    }
    window.__etkObsGlobal=new MutationObserver(passe);
    window.__etkObsGlobal.observe(document.body,{childList:true,subtree:true});
  }

  function suivrePrix(){
    var pc=document.querySelector('.product__info-container .price');
    if(pc && window.MutationObserver){ new MutationObserver(prixNoir).observe(pc,{childList:true,subtree:true,characterData:true}); }
  }
  function tout(){ pdpV2(); prixNoir(); }
  // Leve le rideau pose par le script en ligne du bloc Liquid. Deux rAF : le premier
  // laisse le navigateur appliquer la mise en page issue de tout(), le second peint.
  function revele(){
    var r=document.documentElement;
    if(r && r.classList.contains('etk-attente')) r.classList.remove('etk-attente');
  }
  function go(){
    // 07/09/2026 : le tout premier passage etait retarde de 250 ms, ce qui laissait voir
    // la fiche d'origine. Il part maintenant tout de suite (ce fichier est en defer, le
    // document est donc deja entierement analyse quand on arrive ici).
    var lever=function(){
      if(window.requestAnimationFrame) requestAnimationFrame(function(){ requestAnimationFrame(revele); });
      else revele();
    };
    try{ tout(); suivreVariantes(); } finally { lever(); }
    setTimeout(function(){tout();revele();},250);
    setTimeout(tout,1200);
    setTimeout(function(){window.__etkTard=true;tout();suivrePrix();suivreVariantes();},3000);
    setTimeout(tout,6000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
  window.addEventListener('load',go);
})();

